export default __webpack_public_path__ + "static/media/komi.e2e1b7c0.md";